import { render } from "./MainMenuPrint.vue?vue&type=template&id=530d1ee8&scoped=true"
import script from "./MainMenuPrint.vue?vue&type=script&lang=js"
export * from "./MainMenuPrint.vue?vue&type=script&lang=js"

import "./MainMenuPrint.vue?vue&type=style&index=0&id=530d1ee8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530d1ee8"]])

export default __exports__